module.exports = __webpack_public_path__ + "static/year2002-45f7b2339b91a1b74ada6aa487687dcf.jpg";